<template>
  <div class="ai-generate-actions d-flex flex-column gap-gd-2">
    <!-- Action Buttons Grid -->
    <div class="ai-actions-grid d-flex flex-wrap gap-gd-1">
      <ChipSelect
        mode="mixed"
        :options="allActions"
        option-value="id"
        :option-label-formatter="getTagLabel"
        sub-option-value="id"
        sub-option-label="name"
        :disabled="isLoading"
        @change="handleTagClick"
        @sub-change="handleSubChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChipSelect from '@components_system/Shared/Tools/ChipSelect/ChipSelect.vue';

export default {
  name: 'AIGenerateActions',
  components: {
    ChipSelect,
  },
  props: {
    reviseTags: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    }),
    availableReviseTags() {
      return this.reviseTags || [];
    },
    /** All actions merged into a single array — tags + dropdowns */
    allActions() {
      const createItem = {
        id: 'create',
        labelDirect: this.$t('engine.aiOption.lblCreate', this.languageEngine),
        _isCreate: true,
        _mode: 'tag'
      };

      return [
        createItem,
        ...this.availableReviseTags.map(tag => {
          const hasSubmenu = tag.data && Array.isArray(tag.data) && tag.data.length > 0;
          return {
            ...tag,
            _mode: hasSubmenu ? 'dropdown' : 'tag',
            _subOptions: hasSubmenu ? tag.data : undefined
          };
        })
      ];
    }
  },
  methods: {
    handleTagClick(tag) {
      if (tag._isCreate) {
        this.$emit('action-click', { type: 'create' });
      } else {
        this.$emit('action-click', { type: 'revise', tag });
      }
    },
    handleSubChange({ parent, sub }) {
      let actionType = 'revise';
      const combinedTag = {
        ...parent,
        prompt: sub.prompt || parent.prompt,
        name: sub.name,
        subItemId: sub.id
      };
      if(combinedTag.id == 'translate') {
        actionType = 'translate';
      }
      this.$emit('action-click', { type: actionType, tag: combinedTag });
    },
    getTagLabel(tag) {
      return tag.labelDirect || tag.label || tag.name || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-generate-actions {
  width: 100%;
  .ai-actions-grid {
  width: 100%;
}

}


</style>
